export default "__VITE_ASSET__BXk4neoS__"